import React from 'react';
import './WhyUsSection.css';
import bgImage from '../assets/whyus-bg.webp';
import { Link } from 'react-router-dom';

const WhyUsSection = () => {
  return (
    <section
      className="whyus-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="whyus-overlay">
        <div className="whyus-content container">
          <div className="whyus-left">
            <h2>WHY<br />LATTICE LABS</h2>
          </div>
          <div className="whyus-right">
            <p>
              At Lattice Labs, we create scalable and maintainable digital products that solve real user problems. 
              Our focus is on fast delivery, outstanding design, and measurable business impact.
            </p>
            <Link to="/company/why-us" className="whyus-btn-wrapper">
              <button className="whyus-btn">Know More</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;